import React from "react";
import { Button, Container, Grid, Typography, Link } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import mapIcon from "../../images/Homescreen.svg";
import Blocks from "../../images/resultIcons/Blocks.svg";
import mruLogo from "../../images/mruLogo.png";
import styles from "./styles";

const HomeScreen = ({ classes, setCurrentScreen }) => {
  const handleClick = () => setCurrentScreen("Quiz");
  const logoClick = (e) => {
    e.stopPropagation();
    window.open("https://mru.org");
  };

  return (
    <Grid container className={classes.homeMainScreenContainer}>
      <Grid container className={classes.homeScreenContainer}>
        <Container maxWidth="md">
          <Typography align="center" className={classes.homeTitle}>
            ECON PRACTICE
          </Typography>
          <Grid container justify="center">
            <img src={mapIcon} className={classes.gdpIcon} />
          </Grid>
          <Typography align="center" className={classes.homeQuestion}>
           Functions of Money
          </Typography>
          <Grid container justify="center">
            <Button className={classes.playButton} onClick={handleClick}>
              play
            </Button>
          </Grid>
        </Container>
      </Grid>

      <Grid container justify="space-between" style={{ position: "relative" }}>
        <Grid className={classes.forTeachers} style={{}}>
          <Grid style={{ backgroundColor: '#fff', padding: 15 }}>
            <Typography className={classes.forStudentsTitle}>
              FOR TEACHERS
            </Typography>
            <Link
              href="https://mru.org/inflation"
              target="_blank"
              className={classes.sideBarLink}
            >
              <img src={Blocks} className={classes.linkImg} />
              <Grid>
                <Typography className={classes.sideBarLinkText}>
                  GET UNIT PLAN
                </Typography>
                <Typography className={classes.sideBarLinkText}>
                  Money & Inflation
                </Typography>
              </Grid>
            </Link>
          </Grid>
        </Grid>
        <Grid style={{ padding: "2rem" }} />
        <Grid className={classes.mruLogo}>
          <img src={mruLogo} className={classes.logoImg} onClick={logoClick}/>
        </Grid>
      </Grid>
      {/* <Grid container className={classes.mruLogoContainer}>
        <Grid container justify="flex-end">
          <Link
            href="https://mru.org"
            target="_blank"
            className={classes.mruLogo}
          >
            <img src={mruLogo} className={classes.logoImg} />
          </Link>
        </Grid>
      </Grid> */}
    </Grid>
  );
};

export default withStyles(styles)(HomeScreen);
